import { useState, useEffect } from 'react';

const BASE_URL = 'https://supportai.zapier.com';
const ENDPOINT_PATH = '/api/v1/federated-search/search/';

const useFederatedSearchResults = query => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!query) {
      setResults([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      const sources = [
        'zendesk-help-center',
        'blog',
        'zapier-learn',
        'zapier-community',
      ];
      const url = new URL(`${BASE_URL}${ENDPOINT_PATH}`);
      const params = new URLSearchParams({
        query,
        top_k: "10",
      });

      sources.forEach(source => {
        params.append('source', source);
      });

      url.search = params.toString();

      try {
        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setResults(data.results.matches || []);
      } catch (fetchError) {
        setError(fetchError.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [query]);

  return { results, loading, error };
};

export default useFederatedSearchResults;
